import React from "react";
import { Trans } from "react-i18next";
import { CurrencySymbol, formatCurrency, formatDate } from "services/util";

export const CurrencyConversion = ({
  className,
  history,
  organisation: { BaseCurrency },
  item: { CurrencyCode, CurrencyRate, Total, SubTotal, TotalTax },
  ...props
}) => {
  if (!!BaseCurrency && BaseCurrency !== CurrencyCode) {
    const creation_date = history?.HistoryRecords?.[0]?.DateUTC
    return (
      <>
        <tr>
          <td className="text-start text-nowrap" colSpan="2">
            <strong><Trans>Exchange rate</Trans></strong> {creation_date && <span>({formatDate(creation_date)})</span>}
          </td>
          <td className="d-flex w-100 justify-content-end">
            <div dir="ltr"> 1 <CurrencySymbol currency={BaseCurrency} /> = {CurrencyRate} <CurrencySymbol currency={CurrencyCode} /> </div>
          </td>
        </tr>
        <tr>
          <td className="text-start text-nowrap" colSpan="2">
            <strong><Trans>Total in</Trans> <CurrencySymbol currency={BaseCurrency} /></strong>
          </td>
          <td className="d-flex w-100 justify-content-end">
            {formatCurrency(Total / CurrencyRate || 0)} <CurrencySymbol currency={BaseCurrency} />
          </td>
        </tr>
        {TotalTax > 0 &&
          <tr>
            <td className="text-start text-nowrap" colSpan="2">
              <strong><Trans>Total Tax in</Trans> <CurrencySymbol currency={BaseCurrency} /></strong>
            </td>
            <td className="d-flex w-100 justify-content-end">
              {formatCurrency(TotalTax / CurrencyRate || 0)} <CurrencySymbol currency={BaseCurrency} />
            </td>
          </tr>
        }
      </>
    )
  }
  return null
}

export default CurrencyConversion;
